var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "service-check",
    "class": {
      'service-check--opportunity': _vm.status === 'opportunity'
    },
    attrs: {
      "aria-label": "Kontrola refinancovania",
      "aria-busy": _vm.busy
    }
  }, [_c('div', {
    staticClass: "service-check__heading"
  }, [_c('div', [_vm.busy ? _c('strong', [_c('span', {
    staticClass: "service-check__spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Prepočítavam ponuky bánk…")]) : _vm.status === 'opportunity' ? _c('strong', [_vm._v("Výhodnejšia sadzba · možná úspora " + _vm._s(_vm.eur(_vm.best.savings)) + "/mes.")]) : _vm.status === 'small_saving' ? _c('strong', [_vm._v("Menšia úspora · " + _vm._s(_vm.eur(_vm.best.savings)) + "/mes.")]) : _vm.status === 'no_saving' ? _c('strong', [_vm._v("V porovnaných ponukách teraz nie je nižšia splátka")]) : _vm.status === 'missing_data' ? _c('strong', [_vm._v("Kontrola potrebuje doplniť údaje")]) : _vm.status === 'error' ? _c('strong', [_vm._v("Kontrola sa nepodarila")]) : _vm.status === 'inactive' ? _c('strong', [_vm._v("Úver už nie je aktívny")]) : _c('strong', [_vm._v("Denná kontrola refinancovania")]), _c('p', {
    staticClass: "service-check__meta"
  }, [_vm._v("Denne · upozornenie od 20 €/mes."), _vm.check && _vm.check.checked_at ? _c('span', [_vm._v(" · Posledná kontrola " + _vm._s(_vm.checkedAt))]) : _vm._e()])]), _vm.status !== 'inactive' ? _c('button', {
    staticClass: "service-check__button",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v(_vm._s(_vm.busy ? 'Prebieha kontrola' : 'Skontrolovať teraz'))]) : _vm._e()]), _vm.error ? _c('p', {
    staticClass: "service-check__message",
    attrs: {
      "role": "status"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm.busy ? _c('p', {
    staticClass: "service-check__message",
    attrs: {
      "role": "status"
    }
  }, [_vm._v("Kontrola pokračuje na pozadí, túto kartu môžete zatvoriť.")]) : [!_vm.active ? _c('p', {
    staticClass: "service-check__message"
  }, [_vm._v("Úver je v evidencii neaktívny, automatická kontrola sa nespúšťa.")]) : !_vm.check ? _c('p', {
    staticClass: "service-check__message"
  }, [_vm._v("Prvá automatická kontrola ešte neprebehla. Môžete ju spustiť aj teraz.")]) : _vm._e(), _vm.result.message ? _c('p', {
    staticClass: "service-check__message"
  }, [_vm._v(_vm._s(_vm.result.message))]) : _vm._e(), _vm.status === 'missing_data' ? _c('router-link', {
    staticClass: "service-check__button service-check__link",
    attrs: {
      "to": {
        name: 'KartaHypotekyDetail',
        params: {
          hypoteka: _vm.mortgage.id
        }
      }
    }
  }, [_vm._v("Doplniť údaje hypotéky")]) : _vm._e(), _vm.best ? [_c('div', {
    staticClass: "service-check__offer"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.best.bank_name))]), _vm._v(" · " + _vm._s(_vm.number(_vm.best.rate)) + " % · fix " + _vm._s(_vm.best.fix) + " r.")]), _c('span', [_vm._v("Splátka " + _vm._s(_vm.eur(_vm.result.current_payment)) + " → "), _c('strong', [_vm._v(_vm._s(_vm.eur(_vm.best.payment)))])]), _c('span', [_vm._v("Zostáva " + _vm._s(_vm.result.months) + " mesiacov")])]), _c('p', {
    staticClass: "service-check__meta"
  }, [_vm._v("Orientačná úspora splátky pred započítaním nákladov na refinancovanie.")])] : _vm._e(), _vm.stale ? _c('p', {
    staticClass: "service-check__message"
  }, [_vm._v("Výsledok je starší ako 48 hodín. Pred použitím spustite novú kontrolu.")]) : _vm._e(), _vm.result.assumptions ? _c('details', {
    staticClass: "service-check__details"
  }, [_c('summary', [_vm._v("Podmienky a náklady porovnania"), _vm.result.compared_banks ? _c('span', [_vm._v(" · " + _vm._s(_vm.result.compared_banks) + " bánk")]) : _vm._e()]), _c('p', [_vm._v(_vm._s(_vm.result.assumptions))]), _vm.best ? _c('p', [_vm._v("Poplatok novej banky za poskytnutie: " + _vm._s(_vm.cost(_vm.best.arrangement_fee)) + ". Účet: " + _vm._s(_vm.cost(_vm.best.account_fee)) + "/mes. Náklady na predčasné splatenie, kataster, posudok a poistenie treba doplniť. Čistá úspora a návratnosť preto zatiaľ nie sú vyčíslené.")]) : _vm._e(), _vm.result.unavailable_banks && _vm.result.unavailable_banks.length ? _c('p', [_vm._v("Nie všetky banky sa podarilo vyhodnotiť (" + _vm._s(_vm.result.unavailable_banks.join(', ')) + "). Záver platí len pre porovnané ponuky.")]) : _vm._e()]) : _vm._e()]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }